import {
    SerialNumberSearchPayload
} from "../../../serial-number/SerialNumberPayload"
import SerialNumberItemsResult from "../models/serialNumberItemsResult"
import QueryHelper from "../../../../common/QueryHelper"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import { generateSerialNumberSearchParams } from "../../../../utils"
import { isError } from "../../../helpers/Error"
import { SerialNumberElasticDto } from "../models"

class Service {
    static async findMultipleByProductId(payload: SerialNumberSearchPayload): Promise<SerialNumberItemsResult> {
        const queryParameters = QueryHelper.getQueryParametersStringFromObject(payload, ["productId"])
        const res = await AppContext.getApiClient().get(`/listing/products/${payload.productId}/serial-numbers${queryParameters}`)

        if (res.error) {
            throw new Error(res.error.message)
        }

        return new SerialNumberItemsResult(res)
    }

    static async findAvailableByProductId(payload: SerialNumberSearchPayload): Promise<Array<SerialNumberElasticDto>> {
        const params = generateSerialNumberSearchParams({
            ...payload,
            filters: {
                "productId": payload.productId,
                "isAvailable": true
            }})

        const res = await AppContext.getApiClient()
            .post("/listing/search", params)

        if (isError(res)) {
            throw new Error(res.message)
        }

        return res.data ?? []
    }
}

export {
    Service
}



// WEBPACK FOOTER //
// ./src/state/listing/serial-numbers/service/service.ts